import { WithTooltip } from "shared/table-helpers";
import moment from "moment";
import { MOMENT_LONG_DATE_FORMAT } from "shared/constants";

export const notificationColumns = [
    {
        Header: WithTooltip("Date"),
        accessor: "dateChanged",
        Cell: (row) => {
            const dateString = row.value ? moment.utc(new Date(row.value)).format(MOMENT_LONG_DATE_FORMAT) : "";

            return WithTooltip(dateString);
        },
    },
    {
        Header: WithTooltip("Status"),
        accessor: "displayDescription",
    },
];
